import { CarouselApi } from "@/components-shared/ui/carousel";
import { useCallback, useEffect, useState } from "react";

const useThumb = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [apiMain, setApiMain] = useState<CarouselApi>();
  const [apiThumb, setApiThumb] = useState<CarouselApi>();

  const onThumbClick = useCallback(
    (index: number) => {
      if (!apiMain || !apiThumb) return;
      apiMain.scrollTo(index);
    },
    [apiMain, apiThumb]
  );

  const onSelect = useCallback(() => {
    if (!apiMain || !apiThumb) return;
    setSelectedIndex(apiMain.selectedScrollSnap());
    apiThumb.scrollTo(apiMain.selectedScrollSnap());
  }, [apiMain, apiThumb, setSelectedIndex]);

  useEffect(() => {
    if (!apiMain) return;
    onSelect();

    apiMain.on("select", onSelect).on("reInit", onSelect);
  }, [apiMain, onSelect]);

  return {
    selectedIndex,
    setApiMain,
    setApiThumb,
    onThumbClick,
  };
};

export default useThumb;
